export default __webpack_public_path__ + "static/media/lock-open.d34f3ec2.svg";